
import './css/loading.css';

const Loading = () => (<div className="component loading"></div>);

export default Loading;